export const INVALID_LENGTH_MESSAGE_KEY = 'taxIdInputInvalidLength';
export const INVALID_CHARS_MESSAGE_KEY = 'taxIdInputInvalidCharacters';

export const getNormalizedTaxId = (taxId) =>
  taxId ? taxId.replace(/-|\.|\s/g, '') : '';

const isValidLength = (taxId) =>
  taxId && taxId.length === 9
    ? { isValid: true }
    : { isValid: false, errorMessageKey: INVALID_LENGTH_MESSAGE_KEY };

const hasValidChars = (taxId) =>
  taxId && taxId.match(/[0-9]{9}/)
    ? { isValid: true }
    : { isValid: false, errorMessageKey: INVALID_CHARS_MESSAGE_KEY };

/**
 * Returns information about the validity of the given taxId.
 * The returned value is an object in the shape:
 * {
 *   isValid: boolean,
 *   errorMessageKey: string, // only present if isValid is false
 * }
 *
 * @param {string} taxId taxId to get validity of
 */
export const getTaxIdValidity = (taxId) => {
  const lengthValidity = isValidLength(taxId);
  if (!lengthValidity.isValid) {
    return lengthValidity;
  }

  const characterValidity = hasValidChars(taxId);
  return characterValidity;
};
